import React from 'react';
import { Image } from '@plone/volto/components';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';

const messages = defineMessages({
    defaultImageAlt: {
        id: 'defaultImageAlt',
        defaultMessage:
            'This content has no image, this is a default placeholder.',
    },
});

const PLONE_SCALES_TO_PX = {
    mini: '200px',
    thumb: '400px',
    preview: '400px',
    large: '800px',
    larger: '1000px',
    great: '1200px',
    huge: '1600px',
    default: '100vw',
};

const Picture = ({
    imageBase,
    alt,
    source,
    lazy,
    content,
    className,
    ...props
}) => {
    const intl = useIntl();

    const pictureOptions = config.settings?.pictureOptions;

    let sources = [];
    if (source && Object.keys(pictureOptions).includes(source)) {
        sources = pictureOptions[source];
    } else if (Object.keys(pictureOptions).length > 0) {
        sources = pictureOptions[Object.keys(pictureOptions)[0]];
    }

    const calculatedSizes = sources
        ?.map((opt) => {
            const pxWidth =
                PLONE_SCALES_TO_PX[opt.image] || PLONE_SCALES_TO_PX.default;
            return opt.media ? `${opt.media} ${pxWidth}` : pxWidth;
        })
        .join(', ');

    return imageBase ? (
        <Image
            alt={alt}
            item={content}
            imageField="image"
            src={`${imageBase}/teaser`}
            sizes={calculatedSizes || undefined}
            loading={lazy ? 'lazy' : 'eager'}
            width={content ? '100%' : null}
            height={content ? 'auto' : null}
            className={className}
            fetchpriority={lazy ? 'low' : 'high'}
            {...props}
        />
    ) : (
        <Image
            src={DefaultImageSVG}
            alt={intl.formatMessage(messages.defaultImageAlt)}
            className={`ui small image ${className || ''}`.trim()}
            {...props}
        />
    );
};

export default Picture;
